// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ustepper { width: 100%; }
.ustepper-list {
  display: flex;
  align-items: stretch;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 8px;
}
.ustepper-item {
  flex: 1 1;
  min-width: 0;
  position: relative;
}
.ustepper-item:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 20px;
  left: calc(50% + 24px);
  right: calc(-50% + 24px);
  height: 2px;
  background: var(--borders-color, #e3ebf8);
  z-index: 0;
}
.ustepper-item.is-done:not(:last-child)::after { background: var(--button-color, #c9194a); }
.ustepper-btn {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: none;
  border: 0;
  cursor: pointer;
  text-align: center;
}
.ustepper-btn:disabled { cursor: default; }
.ustepper-btn:focus-visible { outline: 2px solid var(--button-color, #c9194a); outline-offset: 4px; border-radius: 8px; }
.ustepper-dot {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  background: #fff;
  color: #6b7280;
  border: 2px solid var(--borders-color, #e3ebf8);
  transition: all 0.15s ease;
}
.ustepper-item.is-active .ustepper-dot {
  background: var(--button-color, #c9194a);
  border-color: var(--button-color, #c9194a);
  color: #fff;
  box-shadow: 0 0 0 4px rgba(201, 25, 74, 0.12);
}
.ustepper-item.is-done .ustepper-dot {
  background: var(--button-color, #c9194a);
  border-color: var(--button-color, #c9194a);
  color: #fff;
}
.ustepper-item.is-invalid .ustepper-dot {
  background: #fff;
  border-color: #dc2626;
  color: #dc2626;
}
.ustepper-text { display: flex; flex-direction: column; min-width: 0; max-width: 100%; }
.ustepper-label {
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ustepper-item.is-active .ustepper-label,
.ustepper-item.is-done .ustepper-label { color: #111827; }
.ustepper-item.is-invalid .ustepper-label { color: #dc2626; }
.ustepper-hint {
  font-size: 11px;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 575.98px) {
  .ustepper-hint { display: none; }
  .ustepper-dot { width: 32px; height: 32px; font-size: 13px; }
  .ustepper-item:not(:last-child)::after { top: 16px; left: calc(50% + 20px); right: calc(-50% + 20px); }
  .ustepper-label { font-size: 11px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Stepper/Stepper.css"],"names":[],"mappings":"AAAA,YAAY,WAAW,EAAE;AACzB;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,QAAQ;AACV;AACA;EACE,SAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,yCAAyC;EACzC,UAAU;AACZ;AACA,iDAAiD,wCAAwC,EAAE;AAC3F;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;AACA,yBAAyB,eAAe,EAAE;AAC1C,8BAA8B,+CAA+C,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACxH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,0BAA0B;AAC5B;AACA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,WAAW;EACX,6CAA6C;AAC/C;AACA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,eAAe,EAAE;AACvF;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;yCACyC,cAAc,EAAE;AACzD,4CAA4C,cAAc,EAAE;AAC5D;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB,aAAa,EAAE;EAChC,gBAAgB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;EAC5D,yCAAyC,SAAS,EAAE,sBAAsB,EAAE,wBAAwB,EAAE;EACtG,kBAAkB,eAAe,EAAE;AACrC","sourcesContent":[".ustepper { width: 100%; }\n.ustepper-list {\n  display: flex;\n  align-items: stretch;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  gap: 8px;\n}\n.ustepper-item {\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n}\n.ustepper-item:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: calc(50% + 24px);\n  right: calc(-50% + 24px);\n  height: 2px;\n  background: var(--borders-color, #e3ebf8);\n  z-index: 0;\n}\n.ustepper-item.is-done:not(:last-child)::after { background: var(--button-color, #c9194a); }\n.ustepper-btn {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  background: none;\n  border: 0;\n  cursor: pointer;\n  text-align: center;\n}\n.ustepper-btn:disabled { cursor: default; }\n.ustepper-btn:focus-visible { outline: 2px solid var(--button-color, #c9194a); outline-offset: 4px; border-radius: 8px; }\n.ustepper-dot {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 15px;\n  background: #fff;\n  color: #6b7280;\n  border: 2px solid var(--borders-color, #e3ebf8);\n  transition: all 0.15s ease;\n}\n.ustepper-item.is-active .ustepper-dot {\n  background: var(--button-color, #c9194a);\n  border-color: var(--button-color, #c9194a);\n  color: #fff;\n  box-shadow: 0 0 0 4px rgba(201, 25, 74, 0.12);\n}\n.ustepper-item.is-done .ustepper-dot {\n  background: var(--button-color, #c9194a);\n  border-color: var(--button-color, #c9194a);\n  color: #fff;\n}\n.ustepper-item.is-invalid .ustepper-dot {\n  background: #fff;\n  border-color: #dc2626;\n  color: #dc2626;\n}\n.ustepper-text { display: flex; flex-direction: column; min-width: 0; max-width: 100%; }\n.ustepper-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ustepper-item.is-active .ustepper-label,\n.ustepper-item.is-done .ustepper-label { color: #111827; }\n.ustepper-item.is-invalid .ustepper-label { color: #dc2626; }\n.ustepper-hint {\n  font-size: 11px;\n  color: #9ca3af;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 575.98px) {\n  .ustepper-hint { display: none; }\n  .ustepper-dot { width: 32px; height: 32px; font-size: 13px; }\n  .ustepper-item:not(:last-child)::after { top: 16px; left: calc(50% + 20px); right: calc(-50% + 20px); }\n  .ustepper-label { font-size: 11px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
